import { render, staticRenderFns } from "./recent-essays.vue?vue&type=template&id=b68301fe&scoped=true"
import script from "./recent-essays.vue?vue&type=script&lang=js"
export * from "./recent-essays.vue?vue&type=script&lang=js"
import style0 from "./recent-essays.vue?vue&type=style&index=0&id=b68301fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68301fe",
  null
  
)

export default component.exports